import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterCulturalOuting } from '../../../lib/types/models/center/center-cultural-outing'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterCulturalOutings(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getCenterCulturalOutings.url, { id }), query)
    )
    .get<PaginationResponse<CenterCulturalOuting>>()
}
